import * as z from 'zod'

import {
  bracketCeilingSchema,
  compareBracketCeilings,
} from '#dictionary/bracketCeiling'
import {
  compareFilingStatuses,
  filingStatusSchema,
} from '#dictionary/filingStatuses'

import capitalGainsRaw from './capitalGainsBrackets.json'
import federalIncomeRaw from './federalIncomeBrackets.json'

// Federal-level bracket schedules — ordinary income and long-term capital
// gains — legislated separately by the IRS. Same row shape, so one schema
// covers both; two JSON files keep the on-disk data cleanly partitioned.
export const taxFederalBracketSchema = z
  .object({
    year: z.int(),
    filingStatus: filingStatusSchema,
    to: bracketCeilingSchema,
    taxRate: z.number().min(0).max(1),
  })
  .strict()

export type TaxFederalBracket = z.infer<typeof taxFederalBracketSchema>

// Sort at parse time by (year, filingStatus, to) ASC. The bracket-cascade
// contract requires strictly-ascending `to` within a (year, filingStatus)
// group — guarded by invariant tests on both arrays.
const parseAndSort = (raw: unknown): readonly TaxFederalBracket[] =>
  z
    .array(taxFederalBracketSchema)
    .parse(raw)
    .sort(
      (a, b) =>
        a.year - b.year ||
        compareFilingStatuses(a.filingStatus, b.filingStatus) ||
        compareBracketCeilings(a.to, b.to)
    )

export const FEDERAL_INCOME_BRACKETS = parseAndSort(federalIncomeRaw)

export const CAPITAL_GAINS_BRACKETS = parseAndSort(capitalGainsRaw)
